import React from 'react';
import MediaQuery from '../MediaQuery/MediaQuery';
import Style from '../Style';
export default function DynamicCss(_ref) {
  var id = _ref.id,
    css = _ref.css,
    query = _ref.query;
  return /*#__PURE__*/React.createElement(MediaQuery, {
    query: query
  }, id ? /*#__PURE__*/React.createElement(Style, {
    id: id
  }, css) : /*#__PURE__*/React.createElement("style", null, css));
}